import { inject } from '@angular/core';

import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';

import { catchError, throwError } from 'rxjs';

import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { JwtService } from '../services/jwt.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastr = inject(ToastrService);
  const router = inject(Router);
  const jwtService = inject(JwtService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let message = 'Something went wrong';

      switch (error.status) {
        case 0:
          message = 'Unable to connect to server';
          break;

        case 400:
          message = error.error?.message || 'Bad Request';
          break;

        case 401:
          message = error.error?.message || 'Unauthorized';
          jwtService.removeJWT();
          router.navigate(['/auth/login']);
          break;

        case 403:
          message = error.error?.message || 'Forbidden';
          break;

        case 404:
          message = 'API Not Found';
          break;

        case 500:
          message = error.error?.message || 'Internal Server Error';
          break;

        default:
          message = error.error?.message || message;
      }

      toastr.error(message, 'Error');

      return throwError(() => error);
    }),
  );
};
